import React from 'react';

/**
 * Shared loading state component
 * @param {string} message - Loading message to display
 * @param {string} className - Additional CSS classes
 */
function LoadingState({ message = 'Loading...', className = '' }) {
  return (
    <div className={`loading ${className}`}>
      {message}
    </div>
  );
}

export default LoadingState;
